import { transformSizeObjects } from '@customink/project-service-react-components';
import type {
  Color,
  ProjectItem,
  Sizes,
} from '@customink/project-service-react-components';

import type { SelectedSwatch, Swatch } from '@/types';

export type FormState = {
  sizes?: Sizes;
  swatch?: SelectedSwatch;
};

type DefaultValues = {
  currentProductColorId?: Color['id'];
  currentProductName?: Color['name'];
  currentProjectItemColorId?: NonNullable<ProjectItem['product']>['colorId'];
  currentProjectItemSizes?: ProjectItem['sizesQuantities'];
};

export const getDefaultSizes = ({ currentProjectItemSizes }: DefaultValues) =>
  currentProjectItemSizes && currentProjectItemSizes.length > 0
    ? transformSizeObjects(currentProjectItemSizes)
    : {};

export const getDefaultValues = ({
  currentProductColorId,
  currentProductName,
  currentProjectItemSizes,
}: DefaultValues) => ({
  swatch:
    currentProductColorId && currentProductName
      ? { colorId: currentProductColorId, name: currentProductName }
      : undefined,
  sizes: getDefaultSizes({
    currentProjectItemSizes,
  }),
});

export const getSwatchData = ({
  selectedColorId,
  selectedSwatches,
  swatches,
}: {
  selectedColorId?: number;
  selectedSwatches?: Swatch[];
  swatches?: Swatch[];
}) =>
  (swatches || []).map((swatch) => ({
    color: swatch.hex,
    dogEar: (selectedSwatches || []).includes(swatch),
    singlesEnabled: swatch.singlesEnabled,
    startSelected: Boolean(swatch.colorId === selectedColorId),
    trimRgb: swatch.trimRgb,
    value: { colorId: swatch.colorId, name: swatch.name },
  }));
